package com.crowpay.views.screens.contractor

import com.crowpay._id
import com.crowpay.sdk.notNullSession
import com.crowpay.views.components.nav.Form
import com.lightningkite.UUID
import com.lightningkite.kiteui.QueryParameter
import com.lightningkite.kiteui.Routable
import com.lightningkite.kiteui.navigation.mainScreenNavigator
import com.lightningkite.kiteui.navigation.render
import com.lightningkite.kiteui.reactive.Constant
import com.lightningkite.kiteui.reactive.Property
import com.lightningkite.kiteui.reactive.Readable
import com.lightningkite.kiteui.reactive.invoke
import com.lightningkite.kiteui.views.ViewWriter
import com.lightningkite.lightningdb.Condition
import com.lightningkite.lightningdb.Query
import com.lightningkite.lightningdb.sort
import kotlinx.coroutines.launch


@Routable("/contractor/project/{projectId}/create/{acceptedTerms}")
class CreateProjectForm(val projectId: UUID, val acceptedTerms: UUID) : ContractorPage, Form {
    constructor(acceptedTerms: UUID) : this(UUID.random(), acceptedTerms)
    val form = ProjectForm(projectId)

    override val title: Readable<String> get() = form.title
    override val saved: Readable<Boolean> get() = form.saved

    override fun ViewWriter.renderMainContent() {
        launch {
            val session = notNullSession()
            val mostRecent = session.contractorTermsAndConditionsVersions.query(
                Query(
                    condition = Condition.Always,
                    orderBy = sort { it._id.descending() },
                    limit = 1,
                )
            )().firstOrNull()
            val terms = session.contractorTermsAndConditionsAgreements[acceptedTerms]()

            if (terms == null || mostRecent == null || terms.version != mostRecent._id)
                mainScreenNavigator.replace(CreateProject())
        }

        form.render(this)
    }
}